import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e887e3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notice-wrapper" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "notice-head" }
const _hoisted_4 = { class: "notice-title" }
const _hoisted_5 = { class: "notice-date" }
const _hoisted_6 = { class: "notice-content" }

import { reactive, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { getPushMessages, setSingleMsgRead } from '@/apis/index'
import dayjs from 'dayjs'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const state = reactive({
  loading: false,
  notices: [] as any,
  listQuery: {
    msgGroup: 26,
    currentPage: 1,
    pageSize: 10
  },
  total: 0
})

const handleClick = async (item: any) => {
  if (item.readStatus === 1) return
  const { data } = await setSingleMsgRead({
    param: {
      pushId: item.pushId
    }
  })
  if (data.setSingleMsgRead.ok) {
    ElMessage.success('消息已读')
    seatchData()
  }
}

const seatchData = async () => {
  try {
    state.loading = true
    const res = await getPushMessages({
      filter: state.listQuery
    })
    const { code, result } = res?.data?.getPushMessages
    state.notices = result?.data || []
    state.total = result?.total || 0
  } finally {
    state.loading = false
  }
}

const handleSizeChange = (size: number) => {
  state.listQuery.pageSize = size
  seatchData()
}
const handleCurrentChange = (current: number) => {
  state.listQuery.currentPage = current
  seatchData()
}

onMounted(() => {
  seatchData()
})

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.notices, (v, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "notice-item",
        key: i,
        onClick: ($event: any) => (handleClick(v))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass({
          'notice-left': true,
          dot: v.readStatus === 0,
        })
        }, null, 2),
        _createElementVNode("div", {
          class: "notice-right",
          style: _normalizeStyle({
        opacity: v.readStatus === 0 ? 1 : 0.65
      })
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(v.notifyTitle), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(dayjs)(v.createTime).format("YYYY-MM-DD HH:mm:ss")), 1)
          ]),
          _createElementVNode("div", _hoisted_6, _toDisplayString(v.customContent), 1)
        ], 4)
      ], 8, _hoisted_2))
    }), 128)),
    (state.total > 0)
      ? (_openBlock(), _createBlock(_component_el_pagination, {
          key: 0,
          class: "pagination",
          "current-page": state.listQuery.currentPage,
          "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((state.listQuery.currentPage) = $event)),
          "page-size": state.listQuery.pageSize,
          "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((state.listQuery.pageSize) = $event)),
          background: "",
          size: "small",
          layout: "total, sizes, prev, pager, next, jumper",
          total: state.total,
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["current-page", "page-size", "total"]))
      : (_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          "image-size": 200
        }))
  ])), [
    [_directive_loading, state.loading]
  ])
}
}

})